import React from 'react';

export const Space = () => <div style={{ marginBottom: '50px' }}></div>